import React, { useRef, useState, useEffect } from "react";

const Collapse = ({ children, isOpen }) => {
  const ref = useRef(null);
  const [height, setHeight] = useState(isOpen ? "auto" : "0px");

  useEffect(() => {
    if (isOpen) {
      const scrollHeight = ref.current?.scrollHeight;
      setHeight(`${scrollHeight}px`);

      const timeout = setTimeout(() => {
        setHeight("auto");
      }, 300); // match transition duration

      return () => clearTimeout(timeout);
    } else {
      // Collapse to scrollHeight first to enable transition before 0
      if (ref.current) {
        const currentHeight = ref.current.scrollHeight;
        requestAnimationFrame(() => {
          setHeight(`${currentHeight}px`);
          requestAnimationFrame(() => setHeight("0px"));
        });
      } else {
        setHeight("0px");
      }
    }
  }, [isOpen]);

  return (
    <div
      ref={ref}
      style={{
        overflow: "hidden",
        height: height,
        transition: "height 0.3s ease",
      }}
    >
      {children}
    </div>
  );
};

export default Collapse;
